import styled from 'styled-components';

export const SidebarWb = styled.div`
  width: 320px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  padding: 14px 14px 18px;
  gap: 12px;
  background: #16201c;
  border-right: 1px solid #243029;

  &::-webkit-scrollbar {
    width: 14px;
    height: 14px;
  }
  &::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.18);
  }
  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.32);
    border-radius: 7px;
    border: 3px solid transparent;
    background-clip: padding-box;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.5);
    background-clip: padding-box;
  }
`;

export const WbNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 9px;
  padding: 7px 10px;
`;

export const WbNavArrow = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 7px;
  background: rgba(255, 255, 255, 0.08);
  border: none;
  color: #cfe0d2;
  font-size: 16px;
  cursor: pointer;
  font-family: var(--body);
  transition: all 0.15s;
  flex-shrink: 0;

  &:hover:not(:disabled) {
    background: rgba(255, 255, 255, 0.18);
  }
  &:disabled {
    opacity: 0.28;
    cursor: default;
  }
`;

export const WbNavLabel = styled.div`
  flex: 1;
  text-align: center;
  font-size: 11px;
  font-weight: 700;
  color: #8aa090;
  letter-spacing: 0.3px;
  line-height: 1.3;
`;

export const WbNavName = styled.span`
  display: block;
  font-size: 11px;
  color: #8aa090;
  font-weight: 700;
`;

export const WbNavPos = styled.b`
  color: #e8e0d0;
  display: block;
  font-size: 14px;
  margin-top: 2px;
`;

export const WbStepBox = styled.div`
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 11px 13px;
`;

export const WbStepHeading = styled.div`
  font-family: var(--head);
  font-weight: 600;
  font-size: 14px;
  color: #c8a060;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 7px;
`;

export const NumBadge = styled.span`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #ff7a10;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: var(--body);
`;

export const FinishBtn = styled.button`
  background: #2a5a10;
  color: #cdf2a8;
  border: none;
  border-radius: 8px;
  padding: 10px 0;
  font-weight: 700;
  font-size: 14px;
  cursor: pointer;
  font-family: var(--body);
  transition: background 0.15s;

  &:hover:not(:disabled) {
    background: #357015;
  }
  &:disabled {
    opacity: 0.4;
    cursor: default;
  }
`;

export const DeleteBtn = styled.button`
  background: rgba(120, 30, 30, 0.55);
  border: 1px solid rgba(200, 80, 80, 0.4);
  color: #f3bcbc;
  border-radius: 8px;
  padding: 9px 0;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  font-family: var(--body);
  transition: all 0.15s;

  &:hover {
    background: rgba(150, 40, 40, 0.7);
  }
`;

export const CreateTodoBtn = styled.button`
  width: 100%;
  background: rgba(255, 122, 16, 0.18);
  border: 1px solid rgba(255, 122, 16, 0.4);
  color: #ffb06a;
  border-radius: 8px;
  padding: 9px 0;
  font-weight: 700;
  font-size: 13px;
  cursor: pointer;
  font-family: var(--body);
  transition: all 0.15s;

  &:hover:not(:disabled) {
    background: rgba(255, 122, 16, 0.3);
  }
  &:disabled {
    opacity: 0.4;
    cursor: default;
    filter: saturate(0.4);
  }
`;
